import { render } from "./FooterView.vue?vue&type=template&id=6b3fa32f"
const script = {}

import exportComponent from "D:\\Documents\\Development\\carnitas\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__